export default class HomeStakesAnimation {
    static init() {
        const stakes = document.querySelectorAll('.stake-content');

        const loadStakes = () => {
            window.addEventListener('wheel', (event) => {
                if (event.deltaY < 0) {
                    return;
                }

                stakes.forEach((stake) => {
                    const position = stake.getBoundingClientRect();

                    // checking for partial visibility
                    if (! stake.classList.contains('visible')
                        && position.top + 180 < window.innerHeight
                        && position.bottom >= -185
                        && position.bottom <= 1000) {
                        stake.classList.add('visible');
                    }
                });
            });

            // Avoid listen scroll when all stakes are loaded
            if (document.querySelectorAll('.stake-content.visible').length === stakes.length) {
                window.removeEventListener('scroll', loadStakes);
            }
        };

        window.addEventListener('scroll', loadStakes);
    }
}
